module.exports = __webpack_public_path__ + "static/media/markerFilter3.98661aa7.svg";